import React from 'react';
import { connect } from 'react-redux';
import { getFaqs } from 'hb-redux-store/feature/accounts/accounts.action';
import { queryStringToJSON } from 'hb-redux-store/util/miscellaneousServices';
import SecondaryNav from 'components/mweb/SecondaryNav/SecondaryNav';
import Accordion from 'components/common/Accordion/Accordion';
import Loader from 'components/mweb/Skeletons/Loader/Loader';

class FAQList extends React.Component {
  constructor(props) {
    super(props);
    // const qs = queryStringToJSON(props.location.search);
    // const { header = true } = qs;
    // this.header = header;
    // this.rank = this.props.match.params.rank;
    // this.topic = ;

    this.topic = this.props.match
      ? decodeURI(this.props.match.params.faqTopic)
      : props.faqTopic;
  }
  componentDidMount() {
    if (!this.props.faqs) {
      this.props.getFaqs();
    }
  }
  render() {
    const { faqs, loading } = this.props;
    const faq =
      faqs &&
      faqs.find(
        faq => faq.topicName.toLowerCase() === this.topic.toLowerCase()
      );
    return (
      <div className="desktop-faqs-list">
        {loading && <Loader />}
        {!loading && faq?.helpFAQList?.length > 0 && (
          <div className="desktop-faqs-list--div">
            <div className="desktop-faqs--title">
              {faq.topicName.toUpperCase()}
            </div>
            {faq.helpFAQList.map((item, index) => {
              return (
                <Accordion
                  key={`acc-${index}`}
                  title={item.question}
                  content={item.answer}
                />
              );
            })}
          </div>
        )}
        {!loading && !faq && (
          <div>Unable to find help on this topic. Please try again.</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ accountsReducer }) => ({
  faqs: accountsReducer.faqs,
  loading: accountsReducer.loading
});

const mapDispatchToProps = { getFaqs };

export default connect(mapStateToProps, mapDispatchToProps)(FAQList);
